// ============================================
// P0-⑤ 太阳时间（2026-10-15）：真实时间 → 太阳高度/方位
// 6:00 日出 → 12:00 正午（elevation=1）→ 18:00 日落；夜间 elevation<0（星空/月相 P1）
// azimuth：0（东，6:00）→ 1（西，18:00），夜间截断到端点
// ============================================

export interface SunPosition {
  /** 归一化高度：0=地平线，1=正午；夜间为负 */
  elevation: number;
  /** 归一化方位：0=东 → 1=西 */
  azimuth: number;
}

const clamp01 = (v: number) => Math.min(1, Math.max(0, v));

/** 小时（0~24，支持小数）→ 太阳高度/方位（纯函数） */
export function sunFromTime(hours: number): SunPosition {
  const h = ((hours % 24) + 24) % 24;
  // 白天 6..18 映射到相位 0..1；夜间相位为负（<0）或 >1
  const phase = (h - 6) / 12;
  const elevation = Math.sin(Math.PI * phase);
  return { elevation, azimuth: clamp01(phase) };
}

/** 小时 → "HH:MM" 显示 */
export function formatTime(hours: number): string {
  const h = ((hours % 24) + 24) % 24;
  const hh = Math.floor(h);
  const mm = Math.round((h - hh) * 60);
  const carry = mm === 60 ? 1 : 0;
  const mm2 = mm === 60 ? 0 : mm;
  return `${String((hh + carry) % 24).padStart(2, '0')}:${String(mm2).padStart(2, '0')}`;
}
